import { render } from "./FlowPanelElementButtons.vue?vue&type=template&id=55491750&scoped=true&ts=true"
import script from "./FlowPanelElementButtons.vue?vue&type=script&lang=ts"
export * from "./FlowPanelElementButtons.vue?vue&type=script&lang=ts"

import "./FlowPanelElementButtons.vue?vue&type=style&index=0&id=55491750&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55491750"]])

export default __exports__